import React, { useState, useRef, useEffect } from "react";
import '../../../scss/TypeTracNghiem.scss'
import he from 'he';
import { Editor } from "primereact/editor";
import { Toast } from 'primereact/toast';
import { ThiTrucTuyenService } from "services/ThiTrucTuyenService";

const TypeTuLuan = (props) => {
    const { data, overview, userId, indexDF, index } = props;
    const renderHeight = () => {
        if (indexDF == 0) {
            return '100px'
        }
        else if (indexDF == 1) {
            return '200px'
        }
        else {
            return '150px'
        }
    }
    const renderWord = () => {
        if (indexDF == 0) {
            return 10
        }
        else if (indexDF == 1) {
            return 45
        }
        else if (indexDF == 2) {
            return 60
        }
        else {
            if (index == 0) {
                return 75
            }
            else {
                return 255
            }
        }
    }
    let wordCountDF = 0;
    const input = data?.selected?.vanbantraloi;
    if (input != null && input != undefined && input != "" && input.length > 0) {
        const words = input.trim().split(/\s+/);
        wordCountDF = words.filter(word => word.length > 0).length;
    }

    // Convert plain text sang HTML để Quill hiển thị
    const toEditorHtml = (val) => {
        if (!val) return '';
        if (val.startsWith('<')) return val;
        return val
            .split('\n')
            .map(line => `<p>${line || '<br>'}</p>`)
            .join('');
    };

    const editorRef = useRef(null);
    const initializedRef = useRef(false);
    const [text, setText] = useState(data?.selected?.vanbantraloi || '');
    const [wordCount, setWordCount] = useState(wordCountDF);
    const [totalword, settotalword] = useState(renderWord() || 0);
    const toast = useRef(null);

    const handleBlur = async () => {
        const quillEditor = editorRef.current?.getQuill();
        if (!quillEditor) return;
        const plainText = quillEditor.getText();

        const body = {
            user_id: userId,
            id_cauhoi: data.id,
            vanbantraloi: plainText,
            loaibaithi: 1,
            attempt_code: localStorage.getItem('exam_attempt_code') || null,
            dethitructuyen_id: localStorage.getItem('IdDeThi'),
            type_exam: localStorage.getItem('typeExam')
        }
        await ThiTrucTuyenService.submitquestiontuluan(body);
    };

    const onTextChange = (e) => {
        // Bỏ qua tất cả events trước khi khởi tạo xong — tránh Quill init event clobber state
        if (!initializedRef.current) return;

        const newText = e.htmlValue;
        const words = (e.htmlValue || '').trim().split(/\s+/);
        const currentWordCount = words.filter(word => word.length > 0).length;
        setText(newText);
        setWordCount(currentWordCount);
    };

    // onLoad được PrimeReact Editor gọi ngay khi Quill init xong
    const handleEditorLoad = (quillInstance) => {
        const quill = quillInstance || editorRef.current?.getQuill();
        if (!quill) {
            initializedRef.current = true;
            return;
        }

        try {
            const html = toEditorHtml(data?.selected?.vanbantraloi);
            if (html) {
                quill.clipboard.dangerouslyPasteHTML(html);
                const plainText = quill.getText().trim();
                const wc = plainText ? plainText.split(/\s+/).filter(w => w.length > 0).length : 0;
                setWordCount(wc);
                setText(quill.root.innerHTML);
            }
        } catch (e) { }

        initializedRef.current = true;
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="conatiner-div1">
                <div className="d-flex m2-3" style={{ justifyContent: 'start', marginRight: '10%' }}>
                    <div className="mr-3">
                        <span>
                            <span style={{ fontSize: '16px' }}
                                dangerouslySetInnerHTML={{
                                    __html: he.decode(data.vanbancauhoi)
                                }}
                            />
                        </span>
                    </div>
                </div>

                <div className="mt-3 mb-3">
                    {overview ?
                        <div style={{ display: 'table', width: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                            <div style={{ display: 'table-row' }}>
                                <div style={{ display: 'table-cell', textAlign: 'center', fontWeight: 'bold', width: '100%', border: '1px solid black', padding: '10px' }}>
                                    Câu trả lời
                                </div>
                            </div>
                            <div style={{ display: 'table-row' }}>
                                <div style={{ display: 'table-cell', padding: '10px', width: '100%', border: '1px solid black' }}
                                     dangerouslySetInnerHTML={{ __html: text }}
                                >
                                </div>
                            </div>
                        </div>
                        :
                        <div onBlur={handleBlur}>
                            <Editor
                                ref={editorRef}
                                onTextChange={onTextChange}
                                onLoad={handleEditorLoad}
                                style={{ height: renderHeight(indexDF) }}
                                // placeholder="Type your answer here"
                                headerTemplate={
                                    <span className="ql-formats">
                                        <button className="ql-bold" aria-label="Bold"></button>
                                        <button className="ql-italic" aria-label="Italic"></button>
                                        <button className="ql-underline" aria-label="Underline"></button>
                                        <button className="ql-strike" aria-label="Strikethrough"></button>
                                    </span>
                                }
                            />
                            <div style={{ textAlign: 'end', marginTop: '10px', color: wordCount > totalword ? '#e74c3c' : 'inherit' }}>
                                {wordCount > totalword ? 'Word limit reached' : 'Words'} <strong>{wordCount} / {renderWord(indexDF)}</strong>
                            </div>
                        </div>
                    }
                </div>

            </div >


        </>
    );
}

export default TypeTuLuan;